<template>
    <div class="container clearfix">
        <global-header />

        <div class="w cashier">
            <div class="nav_header">
                <h2>收银台</h2>
            </div>

            <white-space />

            <el-form label-position="top" label-width="150px" ref="_form" :rules="rules" :model="form">
                <el-form-item label="支付内容">
                    <el-radio-group v-model="form.pay_scope">
                        <el-radio class="pay-radio" label="tm_deposit" border>付定金<small>（商标价格的50%）</small></el-radio>
                        <el-radio class="pay-radio" label="tm_full" border>付全款</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="支付确认信息">
                    <div class="order-detail">
                        <el-table :data="[order]" style="width: 100%">
                            <el-table-column prop="resource.title" :label="`订单编号：${order_no}`" width="600">
                                <template slot-scope="scope">
                                    <div class="resource" v-if="order">
                                        <div class="icon">
                                            <img :src="order.thumbnail" />
                                        </div>
                                        <div class="info">
                                            <div class="title">
                                                {{ order.name }}
                                            </div>
                                            <div class="id">注册号：{{ order.apply_no }}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="商标价格">
                                <template slot-scope="scope" v-if="order">¥{{ order.price }} </template>
                            </el-table-column>
                            <!-- <el-table-column label="消保金额">
                                <template slot-scope="scope" v-if="data_resource">¥{{ data_resource.price_earnest }} </template>
                            </el-table-column>
                            <el-table-column label="技术年费">
                                <template slot-scope="scope" v-if="data_resource">¥{{ data_resource.price_tech }} </template>
                            </el-table-column> -->
                            <el-table-column label="手续费">
                                <template slot-scope="scope">
                                    0佣金
                                </template>
                            </el-table-column>
                        </el-table>

                        <div class="hj">
                            <div class="label">支付合计</div>
                            <div class="value">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>订单总额：</td>
                                            <td v-if="order">¥{{ order.amount }}</td>
                                        </tr>

                                        <tr>
                                            <td>使用账户余额：</td>
                                            <td>
                                                <template v-if="form.use_balance">
                                                    ¥{{ profile.balance - profile.balance_frozen }}
                                                </template>
                                                <template v-else>
                                                    ¥0
                                                </template>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr class="price">
                                            <td>本次支付金额：</td>
                                            <td v-if="order">¥{{ order_amount }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <template v-if="order_amount_need > 0">
                    <el-form-item label="支付方式" prop="channel">
                        <el-radio-group v-model="form.channel">
                            <el-radio class="pay-radio" label="ebank" border>
                                <img :src="require('../../assets/bank/wy.png')" />
                                网上银行
                            </el-radio>
                            <el-radio class="pay-radio" label="alipay" border>
                                <img :src="require('../../assets/bank/alipay.png')" />
                                支付宝
                            </el-radio>

                            <el-radio class="pay-radio" label="bank" border>
                                <img :src="require('../../assets/bank/zz.png')" /> 银行转账</el-radio
                            >
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="支付方式" v-if="form.channel === 'ebank'" prop="bank_code">
                        <el-radio-group v-model="form.bank_code">
                            <el-radio v-for="b in bank_list" :key="b.value" class="pay-radio" :label="b.value" border>
                                <img :src="require('../../assets/bank/' + b.value + '.png')" :alt="b.name" />
                                {{ b.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </template>

                <el-form-item v-if="form.channel === 'bank'">
                    <div class="recharge-content">
                        <div>
                            <p><span>公司名称：</span>上海亿恒网络科技有限公司</p>
                            <p><span>开户银行：</span>中国建设银行上海市钦州北路支行</p>
                            <p><span>银行账号：</span>3105 0173 5600 0000 0572</p>
                            <p><span>开户行代码：</span>105290073166</p>
                        </div>
                    </div>
                </el-form-item>
                <!-- 
                <el-form-item label="支付金额" style="width:350px" v-if="form.channel == 'ebank' || form.channel == 'alipay'" prop="amount">
                    <el-input v-model="form.amount" readonly> <template slot="append">元</template> </el-input>
                </el-form-item> -->

                <template v-if="form.channel != 'bank'">
                    <el-form-item>
                        <el-checkbox v-model="form.use_balance"
                            >优先使用账户余额<span class="balance"
                                >（可用余额：{{ profile.balance - profile.balance_frozen }}元）</span
                            ></el-checkbox
                        >
                    </el-form-item>

                    <el-form-item label="支付密码" prop="password_pay">
                        <div class="paypwd">
                            <el-input style="width:350px;margin-right:12px;" v-model="form.password_pay" type="password"></el-input>
                            <a href="/personal/password_pay" target="_blank">设置支付密码？</a>
                        </div>
                    </el-form-item>

                    <el-form-item v-if="form.channel != 'bank'">
                        <el-button style="width: 200px;" @click="on_submit" type="primary" v-if="!is_error" :loading="submitting"
                            >立即支付
                        </el-button>

                        <el-button disabled style="width: 200px;" v-else>当前订单有误</el-button>
                    </el-form-item>
                </template>
            </el-form>

            <!-- <white-space />
            <el-alert title="温馨提示" type="info" :closable="false" show-icon>
                <ul class="alert-list">
                    <li>目前只支持借记卡充值，您在支付过程中出现的任何问题，都可以随时致电联系我们：{{ config.tel }}。</li>
                </ul>
            </el-alert> -->
        </div>

        <global-footer />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                submitting: false,
                min_recharge_amount: null,
                max_recharge_amount: null,
                bank_code: null,
                is_error: false,
                rules: {
                    channel: [{ required: true, message: "请选择充值方式", trigger: ["blur", "change"] }],
                    bank_code: [{ required: true, message: "请选择银行", trigger: ["blur", "change"] }],
                    password_pay: [{ required: true, message: "请输入支付密码", trigger: ["blur", "change"] }],
                },
                form: {
                    channel: "ebank",
                    pay_scope: "tm_deposit",
                    amount: null,
                    bank_code: null,
                    order_no: null,
                    use_balance: false,
                },
                data_resource: null,
                order: {},
                order_no: null,
                order_amount: null,
                order_amount_need: 1,
                bank_list: [
                    {
                        name: "杭州银行",
                        value: "04233310",
                    },
                    {
                        name: "南京银行",
                        value: "04243010",
                    },
                    {
                        name: "华夏银行",
                        value: "03040000",
                    },
                    {
                        name: "浙商银行",
                        value: "03160000",
                    },
                    {
                        name: "广东发展银行",
                        value: "03060000",
                    },
                    {
                        name: "中国农业银行",
                        value: "01030000",
                    },
                    {
                        name: "中国邮政储蓄银行",
                        value: "01000000",
                    },
                    {
                        name: "中国银行",
                        value: "01040000",
                    },
                    {
                        name: "北京银行",
                        value: "04031000",
                    },
                    {
                        name: "民生银行",
                        value: "03050000",
                    },
                ],
            };
        },

        created() {
            const query = this.$route.query;
            this.order_no = query["order_no"] ? query["order_no"] : "";
            this.form.order_no = this.order_no;
            this.load_order();
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
        },
        watch: {
            "form.pay_scope"(e) {
                this.order_amount_change();
                this.order_amount_need_change();
            },
            "form.use_balance"(e) {
                this.order_amount_need_change();
            },
        },
        methods: {
            order_amount_need_change() {
                if (this.form.use_balance) {
                    this.order_amount_need = Math.max(this.order_amount - this.profile.balance - this.profile.balance_frozen, 0);
                } else {
                    this.order_amount_need = this.order_amount;
                }
            },
            order_amount_change() {
                if (this.order) {
                    switch (this.form.pay_scope) {
                        case "tm_full":
                            this.order_amount = this.order.amount;
                            break;
                        case "tm_deposit":
                            this.order_amount = this.order.amount_deposit;
                            break;
                    }
                }
            },
            load_order() {
                const loading = this.$loading({
                    lock: true,
                    text: "加载中...",
                });

                this.$http
                    .get("order_trademark/" + this.order_no)
                    .then((response) => {
                        if (response.success) {
                            this.order = response.data;
                            this.form.amount = response.data.amount_deposit;
                            //this.load_resource();

                            this.order_amount_change();
                        } else {
                            this.is_error = true;
                        }
                    })
                    .catch(() => {
                        this.is_error = true;
                    })
                    .then(() => {
                        loading.close();
                    });
            },
            // load_resource() {
            //     this.$http
            //         .get("trademark/" + this.order.resource_id)
            //         .then((response) => {
            //             if (response.success) {
            //                 this.data_resource = response.data;
            //                 this.order_amount_change();
            //             }
            //         })
            //         .catch(() => {})
            //         .then(() => {});
            // },
            on_submit() {
                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        console.log(this.order_amount_need);
                        if (this.order_amount_need > 0) {
                            var newWindow = window.open();
                        }
                        this.$http
                            .post("payment/cashier_trademark", this.form)
                            .then((response) => {
                                if (!response.success) {
                                    if (typeof newWindow != "undefined") {
                                        newWindow.close();
                                    }
                                    this.$alert(response.message, "失败", {
                                        type: "error",
                                        confirmButtonText: "确定",
                                    });

                                    return false;
                                } else {
                                    //如果有链接
                                    if (response.data) {
                                        if (typeof newWindow != "undefined") {
                                            this.$confirm("充值是否已经完成？", "提醒", {
                                                confirmButtonText: "完成",
                                                showClose: false,
                                                closeOnClickModal: false,
                                                cancelButtonText: "关闭",
                                                type: "warning",
                                                beforeClose: (action, instance, done) => {
                                                    if (action === "confirm") {
                                                        this.check_status(response.data.transaction_no);
                                                    }
                                                    done();
                                                },
                                            });

                                            newWindow.location = response.data.url;
                                        } else {
                                            window.location.ref = response.data.url;
                                        }
                                    } else {
                                        if (typeof newWindow != "undefined") {
                                            newWindow.close();
                                        }
                                        //直接跳回详情
                                        window.location.href = "/order_trademark/" + this.order_no;
                                    }
                                }
                            })
                            .catch()
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            check_status(transaction_no) {
                this.$http.get("/payment/status/" + transaction_no).then((response) => {
                    if (response.data.paid_at != 0) {
                        clearInterval(this.timer);

                        this.$router.replace("/order_trademark/" + this.order_no);
                    }
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        /deep/ .el-radio__input {
            display: none;
        }
        /deep/.el-radio__label {
            padding-left: 0;
            margin-left: auto;
            margin-right: auto;

            img {
                width: 15px;
                height: 15px;
                vertical-align: middle;
            }
        }
        .el-form {
            padding: 4px;
        }
        .el-radio {
            min-width: 110px;
            margin-right: 18px;
            margin-bottom: 12px;
        }

        .pay-radio {
            padding: 4px 12px !important;
            display: inline-flex;
            align-items: center;
            margin-left: 0 !important;
        }

        .amount {
            width: 250px;
            font-size: 16px;
            font-weight: bolder;
            line-height: 40px;
            color: #ff622b;
        }
        .recharge-content {
            display: flex;
            div:first-child {
                margin-right: 96px;
            }
        }
        .w {
            min-height: 700px;
            margin-bottom: 72px;
            // height: calc(100vh - 620px);
        }
        .order-detail {
            border: 1px solid #dcdfe6;
            border-radius: 5px;
            overflow: hidden;
            &:after {
                visibility: hidden;
                display: block;
                font-size: 0;
                content: " ";
                clear: both;
                height: 0;
            }
            .resource {
                display: flex;
                align-items: center;
                .icon {
                    width: 50px;
                    height: 50px;
                    margin-right: 8px;
                }
                .info {
                    .title {
                        font-size: 14px;
                    }
                    .id {
                        color: #9e9e9e;
                        font-size: 12px;
                    }
                }
            }

            .hj {
                display: flex;
                align-items: center;
                padding: 12px;
                float: right;
                .label {
                    margin-right: 48px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #303133;
                }
                .value {
                    table {
                        tbody {
                            tr {
                                font-size: 12px;
                                td {
                                    line-height: 24px;
                                    &:first-child {
                                        text-align: right;
                                        padding-right: 24px;
                                    }
                                    &:last-child {
                                        text-align: left;
                                    }
                                }
                                &.price {
                                    font-size: 14px;
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                }
            }
        }
        .balance {
            color: #ff5722;
            font-weight: bold;
        }
        .paypwd {
            display: flex;
        }
    }
</style>
